var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.25C12.0784 5.25 12.75 5.92157 12.75 6.75M15.75 6.75C15.75 9.23528 13.7353 11.25 11.25 11.25C10.7954 11.25 10.3565 11.1826 9.9428 11.0572L8.25 12.75H6.75V14.25H5.25V15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V13.0607C2.25 12.8617 2.32902 12.671 2.46967 12.5303L6.9428 8.0572C6.81742 7.64351 6.75 7.20463 6.75 6.75C6.75 4.26472 8.76472 2.25 11.25 2.25C13.7353 2.25 15.75 4.26472 15.75 6.75Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.991d78383a42adea4352259364f3a694.svg";
export { ForwardRef as ReactComponent };